<script lang="ts">
    import { onMount } from "svelte";
    import {
        Button,
        DatePicker,
        DatePickerInput,
        StructuredList, 
        StructuredListBody, 
        StructuredListHead,
        StructuredListRow, 
        StructuredListCell,
        Tabs,
        Tab, 
        TabContent,
        Grid,
        Row,
        Select,
        SelectItem,
        Column,
        InlineLoading} from "carbon-components-svelte";
    import CaretLeft16 from "carbon-icons-svelte/lib/CaretLeft16";
	import CaretRight16 from "carbon-icons-svelte/lib/CaretRight16";
    import type {Requests} from "../libreries/Requests";
    import {selectedTenant, userStore} from "../stores";
    import type { Tenant } from "../models/Tenant";
    import type { UserModel } from "../models/UserModel";
    import type { Booking} from "../models/Booking";
    import type { Presence} from "../models/Presence";
    import { Helpers } from "../utilities/Helpers";
    import Legend from "./Legend.svelte";
    import moment from "moment";

    export let requests: Requests; //Requests instance from Users.svelte
    let user: UserModel; //Selected user 
    let tenant: Tenant;
    let bookingsToShow: Booking[] = [];
    let presences: Presence[] = [];
    $: offset = 0;
    $: size = "100";
    $: until = "";
    let promiseBookings: Promise<any>;
    let promisePresences: Promise<any>;
    $: isLastPage = false;

    onMount(async () => {
        selectedTenant.subscribe((value) => {
            tenant = value;
        })
        userStore.selectedUser.subscribe((value) => {
            user = value;
        })
        promiseBookings = getBookingsToShow()
        promisePresences = getPresences();
    })

    async function getBookingsToShow(){
        //bookingsToShow = [];
        bookingsToShow = await requests.getUserBookings(tenant.id, user.id, until.replaceAll('/', ''), offset, Number(size));
        if(bookingsToShow.length > 0 && bookingsToShow.length === Number(size)){
            isLastPage = false;
        }else{
            isLastPage = true;
        }
    }

    async function getPresences(){
        presences = await requests.getUserPresences(tenant.id, user.id);
    }

    function goNext(){
        offset = offset + Number(size);
        promiseBookings = getBookingsToShow();
    }

    function goBack(){
        offset = offset - Number(size);
        promiseBookings = getBookingsToShow();
    }
</script>

{#if user}
    <div class="margin-bottom-64">
        <Grid>
            <Row>
                <Column md={2} lg={2}>
                    <div class="user-image" style="background-image: url('{user.photo}');"></div>
                </Column>
                <Column md={6} lg={14}>
                    <div>
                        <StructuredList condensed>
                        <StructuredListBody>
                            <StructuredListRow>
                            <StructuredListCell noWrap>Email</StructuredListCell>
                            <StructuredListCell>{user.email}</StructuredListCell>
                            </StructuredListRow>
                            <StructuredListRow>
                                <StructuredListCell noWrap>Nome</StructuredListCell>
                                <StructuredListCell>{user.firstname}</StructuredListCell>
                            </StructuredListRow>
                            <StructuredListRow>
                                <StructuredListCell noWrap>Secondo nome</StructuredListCell>
                                <StructuredListCell>{user.middlename ? user.middlename : "-"}</StructuredListCell>
                            </StructuredListRow>
                            <StructuredListRow>
                                <StructuredListCell noWrap>Cognome</StructuredListCell>
                                <StructuredListCell>{user.lastname}</StructuredListCell>
                            </StructuredListRow>
                            <StructuredListRow>
                                <StructuredListCell noWrap>Tipo di account</StructuredListCell>
                                <StructuredListCell>{Helpers.switchUserType(user.type)}</StructuredListCell>
                            </StructuredListRow>
                            <StructuredListRow>
                                <StructuredListCell noWrap>Building primario</StructuredListCell>
                                <StructuredListCell>{user.primaryBuilding}</StructuredListCell>
                            </StructuredListRow>
                            <StructuredListRow>
                                <StructuredListCell noWrap>Settore primario</StructuredListCell>
                                <StructuredListCell>{user.primarySector}</StructuredListCell>
                            </StructuredListRow>
                            <StructuredListRow>
                                <StructuredListCell noWrap>Dispositivi</StructuredListCell>               
                                    {#if user.devices}
                                    {#each user.devices as device, item }                   
                                        <StructuredListCell noWrap={true}>
                                            {device.brand}<br>{device.model}<br>versione OS: {device.osVersion}
                                        </StructuredListCell>                       
                                    {/each}
                                    {/if}
                            </StructuredListRow>
                        </StructuredListBody>
                        </StructuredList>         
                    </div>
                </Column>
            </Row>
        </Grid>
    </div>

    <Tabs>
        <Tab label="Prenotazioni" />
        <Tab label="Presenze" />
        <div slot="content">
            <TabContent>
                <div style="display: flex; align-items: flex-end; justify-content: space-between; margin-bottom: 1rem;">
                    <div style="display:flex; align-items: flex-end;">
                        <div>
                            <DatePicker 
                                datePickerType="single"  
                                dateFormat="Y/m/d"
                                minDate={new Date()} 
                                maxDate={moment(new Date()).add(6, 'd').toDate()}
                                bind:value={until}>            
                            <DatePickerInput labelText="Fino al" placeholder="yyyy/mm/dd" />
                            </DatePicker>
                        </div>
                        <Button 
                            style="height:fit-content; margin-left:1rem" 
                            on:click={() => {offset = 0; getBookingsToShow()}}>Cerca</Button>
                    </div>
                    <div>
                        <Legend isBookings={true} greenText="In corso" yellowText="In ritardo" redText="Non si è presentato"/>
                    </div>  
                </div>                 
                <StructuredList condensed>
                    <StructuredListHead>
                    <StructuredListRow head class="header-row">
                        <StructuredListCell head>Data</StructuredListCell>
                        <StructuredListCell head>Orario</StructuredListCell>
                        <StructuredListCell head>Building</StructuredListCell>
                        <StructuredListCell head>Settore</StructuredListCell>
                        <StructuredListCell head>Postazione</StructuredListCell>
                        <StructuredListCell head>Stato</StructuredListCell>
                    </StructuredListRow>
                    </StructuredListHead>
                    <StructuredListBody>
                        {#await promiseBookings}
                            <InlineLoading />
                        {:then}
                            {#if bookingsToShow.length > 0}
                                {#each bookingsToShow as booking, index}
                                <StructuredListRow class={index%2 === 0 ? "even-row" : ""}>
                                    <StructuredListCell>{booking.date}</StructuredListCell>
                                    <StructuredListCell>{booking.time}</StructuredListCell>
                                    <StructuredListCell>{booking.building}</StructuredListCell>
                                    <StructuredListCell>{booking.sector}</StructuredListCell>
                                    <StructuredListCell>{booking.seat}</StructuredListCell>
                                    <StructuredListCell>
                                    {#if booking.status === "NotPresented"}
                                    <span class="state-pill error"></span>
                                    {:else if booking.status === "IsExpected" || booking.status === "Late"}
                                    <span class="state-pill warning"></span>
                                    {:else if booking.status === "Entered"}
                                    <span class="state-pill good"></span>
                                    {/if}
                                    </StructuredListCell>
                                </StructuredListRow>
                                {/each}  
                            {:else}
                                <h6 style="margin: 2rem">Nessuna prenotazione</h6> 
                            {/if}
                        {/await}   
                    </StructuredListBody>
                </StructuredList>
                <!-- Pagination -->
                <div class="bx--pagination">
                    <div class="bx--pagination__left">
                        <label id="select-id-pagination-count-label" class="bx--pagination__text" for="select-id-pagination-count">Prenotazioni per pagina:</label>
                        <Select class="bx--select bx--select--inline bx--select__item-count" bind:selected={size} on:change={() => {offset = 0; getBookingsToShow()}}>
                            <SelectItem value="10" />
                            <SelectItem value="20" />
                            <SelectItem value="50" />
                            <SelectItem value="100" />
                        </Select>
                        <span class="bx--pagination__text bx--pagination__items-count">{offset + 1 } - {offset + bookingsToShow.length}</span>
                    </div>
                    <div class="bx--pagination__right">
                        <div class="bx--pagination__control-buttons">
                            <Button 
                                disabled={offset === 0}
                                class="bx--pagination__button bx--pagination__button--backward bx--btn bx--btn--ghost bx--tooltip--hidden bx--btn--icon-only bx--tooltip__trigger bx--tooltip--a11y bx--btn--icon-only--top bx--tooltip--align-center" 
                                icon={CaretLeft16}
                                iconDescription="Indietro"
                                on:click={goBack}
                            />
                            <Button 
                                disabled={isLastPage}
                                class="bx--pagination__button bx--pagination__button--forward bx--btn bx--btn--ghost bx--tooltip--hidden bx--btn--icon-only bx--tooltip__trigger bx--tooltip--a11y bx--btn--icon-only--top bx--tooltip--align-end" 
                                icon={CaretRight16} 
                                iconDescription="Avanti"
                                on:click={goNext}
                            />
                        </div>
                    </div>
                </div>
            </TabContent>
            <TabContent>
                <div class="pdf-content">
                    <h4 class="margin-top-32 margin-bottom-16">
                        Presenze dell'utente {user.firstname} {user.lastname}, il {(moment(new Date())).format('DD-MMM-YYYY HH:mm:ss')}
                    </h4>
                    <StructuredList condensed>
                        <StructuredListHead>
                        <StructuredListRow head class="header-row">
                            <StructuredListCell head>Data</StructuredListCell>
                            <StructuredListCell head>Building</StructuredListCell>
                            <StructuredListCell head>Orario ingresso</StructuredListCell>
                            <StructuredListCell head>Gate ingresso</StructuredListCell>
                            <StructuredListCell head>Orario uscita</StructuredListCell>
                            <StructuredListCell head>Gate uscita</StructuredListCell>
                        </StructuredListRow>
                        </StructuredListHead>
                        <StructuredListBody>
                            {#await promisePresences}
                                <InlineLoading />
                            {:then}
                                {#if presences.length > 0}
                                    {#each presences as presence, index}
                                    <StructuredListRow class={index%2 === 0 ? "even-row" : ""}>
                                        <StructuredListCell>{presence.dateIn}</StructuredListCell>
                                        <StructuredListCell>{presence.building}</StructuredListCell>
                                        <StructuredListCell>{presence.timeIn}</StructuredListCell>
                                        <StructuredListCell>{presence.gateIn}</StructuredListCell>
                                        <StructuredListCell>{presence.timeOut}</StructuredListCell>
                                        <StructuredListCell>{presence.gateOut}</StructuredListCell>
                                    </StructuredListRow>
                                    {/each}    
                                {:else}
                                    <h6 style="margin: 2rem">Nessuna presenza</h6>
                                {/if}  
                            {/await}
                        </StructuredListBody>
                    </StructuredList>
                </div>
                <Button on:click={() => Helpers.exportToPDF(user.id)} id="cmd" class="margin-top-24">Salva in PDF</Button>      
            </TabContent>
        </div>
    </Tabs>
{/if}